module.exports = ".hot-point-form {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n  .hot-point-form .info {\n    width: calc(100% - 240px);\n    margin-left: 20px; }\n  .hot-point-form .info textarea {\n      height: 80px;\n      resize: none; }\n  .hot-point-form .coordinates {\n    width: 100px;\n    margin-left: 20px; }\n  .hot-point-form mat-form-field {\n    width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/products/product-hot-point-form/product-hot-point-form.component.scss
// module id = ./libs/atenea-cms-brand/src/products/product-hot-point-form/product-hot-point-form.component.scss
// module chunks = main